export default "__VITE_ASSET__Bbvj5IG2__"